function _(t,n,o){var r=t(31),s=/^\s*class[\s{\/}]/,c=Function.prototype.toString;n.exports=function(t){return!!r(t)&&!s.test(c.call(t))}}
//# sourceMappingURL=is.min.js.map